// useQuizHandler.js
"use client";

import { useEffect } from "react";
import { useAxios } from "../../../../hooks/useAxios";

export function useQuizHandler(item) {
    const { post } = useAxios();

    useEffect(() => {
        let antwoord = '';
        const antwoorden = Array.from(document.getElementsByClassName('answer'));
        const vraag = document.getElementsByClassName('question');
        const goedAntwoordElement = document.getElementById('goedAntwoord');
        const foutAntwoordElement = document.getElementById('foutAntwoord');
        const vraagCheckButton = document.getElementsByClassName('vraag_check');
        const volgendeVraagButton = document.getElementsByClassName('volgendeVraag');

        if (
            vraag.length === 0 ||
            antwoorden.length === 0 ||
            vraagCheckButton.length === 0 ||
            volgendeVraagButton.length === 0 ||
            !foutAntwoordElement ||
            !goedAntwoordElement
        ) return;

        const submitAntwoord = (antwoord) => {
            const juistAntwoord = antwoord.hasAttribute('data-antwoord');

            const data = {
                handeling: 'Quiz',
                url: window.location.href,
                naam: vraag[0]?.innerText || '',
                wiki_item_id: item.id,
                extra: {
                    value: antwoord.value,
                    antwoord: juistAntwoord ? 'goed' : 'fout',
                },
            };

            post('/log', data);

            if (juistAntwoord) {
                goedAntwoordElement.style.display = 'block';
                foutAntwoordElement.style.display = 'none';
                volgendeVraagButton[0].style.display = 'block';
                vraagCheckButton[0].style.display = 'none';
            } else {
                goedAntwoordElement.style.display = 'none';
                foutAntwoordElement.style.display = 'block';
                volgendeVraagButton[0].style.display = 'none';
            }
        };

        const handleChange = (e) => {
            antwoorden.forEach((x) => {
                x.checked = false;
            });

            goedAntwoordElement.style.display = 'none';
            foutAntwoordElement.style.display = 'none';
            volgendeVraagButton[0].style.display = 'none';
            vraagCheckButton[0].style.display = 'block';
            e.target.checked = true;
            antwoord = e.target;
        };

        const handleClick = () => {
            if (antwoord) {
                submitAntwoord(antwoord);
            }
        };

        antwoorden.forEach((el) => el.addEventListener('change', handleChange));
        vraagCheckButton[0].addEventListener('click', handleClick);

        // Cleanup on unmount
        return () => {
            antwoorden.forEach((el) => {
                el.removeEventListener('change', handleChange);
            });

            if (vraagCheckButton.length > 0 && vraagCheckButton[0]) {
                vraagCheckButton[0].removeEventListener('click', handleClick);
            }
        };

    }, [item, post]);
}
